import { JSX } from 'react';

import { RHFTextInput } from 'components/input/RHFTextInput';
import { Flex } from 'components/layout';

export function OperatorSectionForm(): JSX.Element {
  return (
    <Flex direction='col' gap='sm' className='w-full'>
      <RHFTextInput name='operator' label='Assigned Operator' readOnly={true} />
    </Flex>
  );
}
